"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.replace");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _auth = require("@/utils/auth");
var _store = _interopRequireDefault(require("@/store"));
var _goods = require("@/api/goods/goods");
var _upgradeStrategy = require("@/api/basic/upgradeStrategy");
var _storeMenuDialog = _interopRequireDefault(require("@/views/goods/component/storeMenuDialog.vue"));
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'goodsManage',
  components: {
    SwPage: _SwPage.default,
    storeMenuDialog: _storeMenuDialog.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        categories: [],
        goodsType: null,
        status: null
      },
      resPath: "",
      editVisible: false,
      categories: [],
      editForm: {
        id: null,
        brandName: '',
        categories: []
      },
      previewDialog: {
        visible: false,
        url: ''
      },
      uploadFileList: [],
      editRules: {
        goodsName: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        categories: [{
          required: true,
          message: '请选择商品分类',
          trigger: 'blur'
        }]
      },
      makeMethodFilter: {
        goodsId: null,
        unitId: null
      },
      makeMethods: [],
      makeMethodVisible: false,
      makeMethodData: [],
      makeMethodAddVisible: false,
      addMakeMethodForm: {
        unitId: null,
        makeMethodIds: []
      },
      unitList: [],
      detailVisible: false,
      detailData: [],
      detailAddVisible: false,
      detailAddQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        groupId: null
      },
      detailAddTotal: 0,
      detailAddData: [],
      storeMenuVisible: false,
      // 添加控制弹窗显示的变量
      regionStoreList: [],
      // 添加区域门店列表数据
      storeMenuForm: {
        relatedStoreIdList: [] // 添加已选择门店ID列表
      },
      batchOperateVisible: false,
      batchOperateData: {},
      batchOperateUploadUrl: "/mall/xyGoods/batchUploadUpdateExcel",
      baseURL: process.env.VUE_APP_PIM_API,
      storeImageImportVisible: false,
      storeImageUploadUrl: "/mall/xyGoods/importStoreImages",
      newStoreImageImportVisible: false,
      imagePoolUploadUrl: "/mall/xyGoods/uploadStoreImagesPool",
      newStoreImageExcelUploadUrl: "/mall/xyGoods/importStoreGoodsImages",
      imagePoolUploading: false,
      imagePoolUploadMsg: "",
      excelImporting: false,
      importResultData: null
    };
  },
  created: function created() {
    // 接收路由参数
    if (this.$route.query.keywords) {
      this.listQuery.keywords = this.$route.query.keywords;
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          keywords: undefined
        })
      });
    }
    this.getList();
    this.getResPathInfo();
    this.getCategories();
    this.getMakeMethods();
    this.getUnitList();
    this.queryRegionStoreList();
  },
  computed: {
    // 计算属性的 getter
    headers: function headers() {
      return {
        "X-Token": _store.default.getters.token || (0, _auth.getToken)()
      };
    }
  },
  methods: {
    handleFlashGoodMenu: function handleFlashGoodMenu(goodId) {
      var _this = this;
      (0, _goods.flushedXyGoods)(goodId).then(function (res) {
        if (res.code == 0) {
          _this.$message({
            message: res.message,
            type: "success"
          });
        } else {
          _this.$message({
            message: res.message,
            type: "error"
          });
        }
        return;
      });
    },
    handleSyncMakeMethod: function handleSyncMakeMethod() {
      (0, _goods.syncMakeMethod)().then(function (res) {});
    },
    // 下载导入模板
    handleDownloadTemplate: function handleDownloadTemplate() {
      var _this2 = this;
      if (!this.batchOperateData.type) {
        this.$message({
          message: "请先选择导入类型",
          type: "error"
        });
        return;
      }
      (0, _goods.downloadImportTemplate)(this.batchOperateData.type).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "\u5BFC\u5165\u6A21\u677F_".concat(_this2.batchOperateData.type, ".xlsx");
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(function (error) {
        console.error('下载失败:', error);
        _this2.$message.error('下载失败');
      });
    },
    handleUploadUpdate: function handleUploadUpdate() {
      this.batchOperateVisible = true;
    },
    handleFileSuccess: function handleFileSuccess(response, file, fileList) {
      if (file.response.code === 200) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.uploadVisible = false;
        this.getList();
      } else {
        this.$message.error(file.response.msg);
        //删除上传列表中，失败的文件
        var index = 0;
        for (var i in fileList) {
          if (fileList[i] == file) {
            index = i;
            break;
          }
        }
        //移出当前文件对象
        fileList.splice(index, 1);
      }
    },
    submitUpload: function submitUpload() {
      this.$refs.upload.submit();
    },
    submitBatchOperateUpload: function submitBatchOperateUpload() {
      var _this3 = this;
      this.$refs["batchOperateForm"].validate(function (valid) {
        if (valid) {
          _this3.$refs.uploadBatchOperate.submit();
        } else {
          return;
        }
      });
    },
    queryRegionStoreList: function queryRegionStoreList() {
      var _this4 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        var data = res.data;
        if (data) {
          _this4.regionStoreList = data.storeRegions || [];
        }
      });
    },
    handleSyncGoods: function handleSyncGoods(id) {
      var _this5 = this;
      if (id) {
        // 单个商品同步逻辑保持不变
        this.$confirm('确认同步数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          (0, _goods.syncGoodsById)({
            id: id
          }).then(function (res) {
            _this5.$message.success('操作成功');
            _this5.getList();
          });
        }).catch(function () {});
      } else {
        // 全量同步时打开门店选择弹窗
        this.storeMenuVisible = true;
      }
    },
    handleFullSyncGoods: function handleFullSyncGoods(data) {
      var _this6 = this;
      this.$confirm('确认进行全量同步商品操作吗？同步将在后台执行，请勿重复操作。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.listLoading = true;
        (0, _goods.fullSyncGoods)({
          storeIds: data.relatedStoreIdList
        }).then(function (res) {
          _this6.storeMenuVisible = false;
          _this6.listLoading = false;
          _this6.$alert('同步已在执行，执行会持续一段时间，请不要重复进行同步操作。', '操作成功', {
            confirmButtonText: '确定',
            callback: function callback(action) {}
          });
        }).catch(function () {
          _this6.listLoading = false;
        });
      }).catch(function () {});
    },
    handlePriceSyncFlag: function handlePriceSyncFlag(id, priceSyncFlag) {
      var _this7 = this;
      var text = '';
      if (priceSyncFlag === 1) {
        text = '开启';
      } else if (priceSyncFlag === 0) {
        text = '关闭';
      }
      (0, _goods.update)({
        id: id,
        priceSyncFlag: priceSyncFlag
      }).then(function (res) {
        if (res.code === 0) {
          _this7.$message.success('操作成功');
          _this7.getList();
        }
      });
    },
    handleStatus: function handleStatus(id, status) {
      var _this8 = this;
      var text = '';
      if (status == 1) {
        text = '上架';
      } else if (status == 0) {
        text = '下架';
      }
      (0, _goods.update)({
        id: id,
        status: status
      }).then(function (res) {
        if (res.code === 0) {
          _this8.$message.success('操作成功');
          _this8.getList();
        }
      });
    },
    deleteDetail: function deleteDetail(id) {},
    getDetailInfo: function getDetailInfo() {},
    openDetailDialog: function openDetailDialog(id) {
      var _this9 = this;
      (0, _goods.getGoodsDetailGroup)({
        goodsId: id
      }).then(function (res) {
        _this9.detailData = res.data;
        _this9.detailVisible = true;
      });
    },
    handleDetailAddFilter: function handleDetailAddFilter() {},
    handleOpenEstimateInfo: function handleOpenEstimateInfo(row) {
      this.$emit('open-estimateInfo', {
        id: row
      });
    },
    handleOpenGoodsMakeMethod: function handleOpenGoodsMakeMethod(row) {
      this.$emit('open-goodsMakeMethod', {
        id: row
      });
    },
    openEditInTab: function openEditInTab(row) {
      this.$emit('open-edit', {
        id: row.id,
        title: "\u7F16\u8F91 - ".concat(row.goodsName)
      });
    },
    openAddInTab: function openAddInTab() {
      this.$emit('open-add');
    },
    getRowKey: function getRowKey(row) {
      return row.id + '_' + row.name + '_' + row.data;
    },
    getUnitList: function getUnitList() {
      var _this0 = this;
      (0, _goods.getUnitList)().then(function (res) {
        _this0.unitList = res.data;
      });
    },
    addMakeMethod: function addMakeMethod() {
      var _this1 = this;
      this.$confirm('确认添加吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _goods.addGoodsMakeMethod)({
          goodsId: _this1.makeMethodFilter.goodsId,
          makeMethodIds: _this1.addMakeMethodForm.makeMethodIds,
          unitId: _this1.addMakeMethodForm.unitId
        }).then(function (res) {
          if (res.code === 200) {
            _this1.$message.success('操作成功');
            _this1.getMakeMethodInfo();
            _this1.makeMethodAddVisible = false;
          }
        });
      }).catch(function () {});
    },
    getMakeMethodInfo: function getMakeMethodInfo() {
      var _this10 = this;
      this.listLoading = true;
      (0, _goods.getGoodsMakeMethodInfo)(this.makeMethodFilter).then(function (res) {
        _this10.makeMethodData = res.data;
        _this10.listLoading = false;
      });
    },
    deleteMakeMethod: function deleteMakeMethod(id) {
      var _this11 = this;
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _goods.deleteGoodsMakeMethod)({
          id: id
        }).then(function (res) {
          if (res.code === 200) {
            _this11.$message.success('删除成功');
            _this11.getMakeMethodInfo();
          }
        });
      }).catch(function () {});
    },
    openMakeMethodDialog: function openMakeMethodDialog(id) {
      this.makeMethodVisible = true;
      this.makeMethodFilter.goodsId = id;
      this.getMakeMethodInfo();
    },
    getMakeMethods: function getMakeMethods() {
      var _this12 = this;
      (0, _goods.getMakeMethodTree)().then(function (res) {
        _this12.makeMethods = res.data;
      });
    },
    getCategories: function getCategories() {
      var _this13 = this;
      (0, _goods.getCategoryTree)().then(function (res) {
        _this13.categories = res.data;
      });
    },
    getResPathInfo: function getResPathInfo() {
      // getImagePrefix().then(res => {
      //   this.resPath = res.data
      // })
    },
    getList: function getList() {
      var _this14 = this;
      this.listLoading = true;
      // 构建查询参数，排除 categories 数组
      var params = _objectSpread({}, this.listQuery);
      delete params.categories;
      (0, _goods.queryList)(params).then(function (response) {
        if (response) {
          _this14.dataList = response.records;
          _this14.total = response.total;
        }
        setTimeout(function () {
          _this14.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this14.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      // 将分类数组转换为 categoryFirstId 和 categorySecondId
      if (this.listQuery.categories && this.listQuery.categories.length > 0) {
        this.listQuery.categoryFirstId = this.listQuery.categories[0];
        this.listQuery.categorySecondId = this.listQuery.categories[1] || null;
      } else {
        this.listQuery.categoryFirstId = null;
        this.listQuery.categorySecondId = null;
      }
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.listQuery.limit = size;
      this.listQuery.page = 1;
      this.getList();
    },
    handleStoreImageImport: function handleStoreImageImport() {
      this.storeImageImportVisible = true;
    },
    handleDownloadStoreImageTemplate: function handleDownloadStoreImageTemplate() {
      var _this15 = this;
      (0, _goods.downloadStoreImageTemplate)().then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '门店图片导入模板.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(function (error) {
        console.error('下载失败:', error);
        _this15.$message.error('下载失败');
      });
    },
    handleStoreImageSuccess: function handleStoreImageSuccess(response, file, fileList) {
      if (response.code === 200 || response.code === 0) {
        this.$message({
          message: response.data.message || "导入成功",
          type: "success"
        });
        this.storeImageImportVisible = false;
        this.getList();
      } else {
        this.$message.error(response.msg || "导入失败");
        var index = 0;
        for (var i in fileList) {
          if (fileList[i] == file) {
            index = i;
            break;
          }
        }
        fileList.splice(index, 1);
      }
    },
    submitStoreImageUpload: function submitStoreImageUpload() {
      this.$refs.uploadStoreImage.submit();
    },
    handleNewStoreImageImport: function handleNewStoreImageImport() {
      var _this16 = this;
      this.newStoreImageImportVisible = true;
      this.imagePoolUploadMsg = "";
      this.importResultData = null;
      this.$nextTick(function () {
        if (_this16.$refs.uploadImagePool) {
          _this16.$refs.uploadImagePool.clearFiles();
        }
        if (_this16.$refs.uploadExcelFile) {
          _this16.$refs.uploadExcelFile.clearFiles();
        }
      });
    },
    submitImagePoolUpload: function submitImagePoolUpload() {
      if (!this.$refs.uploadImagePool || this.$refs.uploadImagePool.uploadFiles.length === 0) {
        this.$message.warning("请先选取要上传的图片或压缩包");
        return;
      }
      this.imagePoolUploading = true;
      this.imagePoolUploadMsg = "";
      this.$refs.uploadImagePool.submit();
    },
    handleImagePoolSuccess: function handleImagePoolSuccess(response, file, fileList) {
      this.imagePoolUploading = false;
      if (response.code === 200 || response.code === 0) {
        var msg = response.data && response.data.message ? response.data.message : response.msg || "素材上传成功";
        this.imagePoolUploadMsg = msg;
        this.$message.success(msg);
      } else {
        this.$message.error(response.msg || "素材上传失败");
      }
    },
    handleImagePoolError: function handleImagePoolError(err) {
      this.imagePoolUploading = false;
      this.$message.error("上传素材发生错误，请检查网络或控制台");
    },
    handleDownloadNewStoreImageTemplate: function handleDownloadNewStoreImageTemplate() {
      var _this17 = this;
      (0, _goods.downloadNewStoreImageTemplate)().then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '门店商品图片导入模板(新版).xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(function (error) {
        console.error('下载模板失败:', error);
        _this17.$message.error('下载模板失败');
      });
    },
    submitNewStoreImageExcelUpload: function submitNewStoreImageExcelUpload() {
      if (!this.$refs.uploadExcelFile || this.$refs.uploadExcelFile.uploadFiles.length === 0) {
        this.$message.warning("请先选取要导入的 Excel 文件");
        return;
      }
      this.excelImporting = true;
      this.importResultData = null;
      this.$refs.uploadExcelFile.submit();
    },
    handleNewStoreImageExcelSuccess: function handleNewStoreImageExcelSuccess(response, file, fileList) {
      this.excelImporting = false;
      if (response.code === 200 || response.code === 0) {
        var resData = response.data || {};
        this.importResultData = resData;
        this.$message.success(resData.message || "导入完成！");
        this.getList();
      } else {
        this.$message.error(response.msg || "导入处理失败");
      }
    },
    handleNewStoreImageExcelError: function handleNewStoreImageExcelError(err) {
      this.excelImporting = false;
      this.$message.error("导入 Excel 文件失败，请重试");
    }
  }
};